import { ProformaInvoice } from '../types';
import { client } from './axiosClient';

export const getProformaInvoices = async (company_id: string | undefined) => {
  const res = await client.get<ProformaInvoice[]>('/client/proforma-invoices', {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const postDownloadProformaInvoice = async (
  id: number,
  company_id: string | undefined
) => {
  const res = await client.post<string>(
    `/client/proforma-invoices/${id}/download`,
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};
